(() => {
  if (window.HOPDesignSearch) return;

  const baseQuery = 'tag:canvas AND -tag:hide';
  const materialWords = new Set(['canvas', 'canvassen', 'wandkleed', 'wandkleden', 'aluminium', 'dibond', 'plexiglas', 'papier', 'poster', 'posters', 'schilderij', 'schilderijen', 'muurcirkel', 'muurcirkels', 'hout', 'artframe', 'akoestisch', 'akoestische', 'paneel', 'panelen']);

  function query(terms) {
    const words = (String(terms).normalize('NFKC').toLocaleLowerCase('nl').match(/[\p{L}\p{N}]+/gu) || []).slice(0, 20);
    const designWords = words.filter(word => !materialWords.has(word));
    if (!words.length) return baseQuery + ' AND title:hopemptysearchtoken';
    return baseQuery + designWords.map(word => ` AND (title:${word}* OR tag:${word}* OR body:${word}*)`).join('');
  }

  function termsFromURL(url) {
    const current = url.searchParams.get('q') || '';
    const saved = url.searchParams.get('hop_q');
    if (saved !== null && query(saved) === current) return saved;
    if (current.startsWith(baseQuery)) {
      const words = Array.from(current.matchAll(/\(title:([^*]+)\*/g), match => match[1]);
      return words.join(' ') || 'canvas';
    }
    return current;
  }

  function searchURL(input, terms) {
    const url = new URL(input, location.origin);
    const value = String(terms === undefined ? termsFromURL(url) : terms).trim();
    url.searchParams.set('q', query(value));
    url.searchParams.set('hop_q', value);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'none');
    return url;
  }

  function isSearchURL(url) {
    return url.origin === location.origin && /\/search\/?$/.test(url.pathname);
  }

  window.HOPDesignSearch = { query, url: searchURL, termsFromURL };

  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const input = form.querySelector('.main-search__input[name="q"]');
    if (!input) return;
    const url = new URL(form.action, location.href);
    if (!isSearchURL(url)) return;
    event.preventDefault();
    if (!input.value.trim()) { input.focus(); return; }
    new FormData(form).forEach((value, key) => url.searchParams.set(key, value));
    const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
    if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
    location.assign(searchURL(url, input.value));
  }, true);

  document.addEventListener('click', event => {
    const link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, location.href);
    if (isSearchURL(url) && url.searchParams.has('q')) link.href = searchURL(url).href;
  }, true);

  const current = new URL(location.href);
  if (isSearchURL(current) && current.searchParams.has('q') && !current.searchParams.has('view')) {
    const terms = termsFromURL(current);
    const canonical = searchURL(current, terms);
    if (terms.trim() && (current.searchParams.get('q') !== canonical.searchParams.get('q') || current.searchParams.get('type') !== 'product')) {
      location.replace(canonical);
      return;
    }
    document.querySelectorAll('.main-search__form .main-search__input[name="q"]').forEach(input => { input.value = terms; });
    document.title = document.title.replace(current.searchParams.get('q'), terms);
  }
})();
